var supportedLocales = ['en-US']
/**
 * `en-US` I18n data for the login component.
 *
 * @access protected
 * @memberof Opal.I18n.app_base
 * @namespace Opal.I18n.app_base.components~en-US
 */
_.each(supportedLocales, function (locale) {
  'use strict'

  Opal.I18n[locale].translation.app_base.components =
    Opal.I18n[locale].translation.app_base.components || {}
})
